import { render, staticRenderFns } from "./UpgraderItems.vue?vue&type=template&id=ab74661e&scoped=true"
import script from "./UpgraderItems.vue?vue&type=script&lang=js"
export * from "./UpgraderItems.vue?vue&type=script&lang=js"
import style0 from "./UpgraderItems.vue?vue&type=style&index=0&id=ab74661e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab74661e",
  null
  
)

export default component.exports